<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Informar Pago</h1>
              <div class="text-caption grey--text font-weight-medium">Validación de Comprobantes Externos</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8 justify-center">
          <v-col cols="12" md="10" lg="8">
            <v-card flat class="rounded-xl glass-card-heavy pa-8 shadow-premium">
              <div class="d-flex align-center mb-8">
                <div class="elite-icon-box mr-4">
                    <v-icon color="primary">mdi-receipt-text-check-outline</v-icon>
                </div>
                <div>
                    <h2 class="text-h5 font-weight-black prism-heading">Detalle de la Acreditación</h2>
                    <p class="text-caption grey--text mb-0">Indique las cuotas que abonó o detalle su consulta de pagos.</p>
                </div>
              </div>

              <!-- Input Section -->
              <v-row>
                <v-col cols="12">
                   <div class="text-overline font-weight-black mb-2 primary--text">Conceptos Abonados</div>
                   <v-textarea
                    v-model="titulo"
                    placeholder="Ej: Cuota Marzo / Matrícula 2026..."
                    outlined
                    flat
                    hide-details
                    required
                    class="rounded-xl elite-input mb-8"
                    rows="4"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                   <div class="text-overline font-weight-black mb-2 primary--text">Comprobante Digital</div>
                   <div class="elite-upload-zone pa-6 rounded-xl border-dashed mb-8 transition-all">
                      <div class="text-center mb-4 d-flex flex-column align-center">
                         <v-icon color="primary" size="48" class="mb-2">mdi-cloud-upload-outline</v-icon>
                         <div class="text-body-2 grey--text text--darken-2 font-weight-medium">Suelte sus archivos aquí o haga clic para seleccionar</div>
                         <div class="text-tiny grey--text">Formatos permitidos: JPG, PNG, PDF. Imagen nítida del comprobante.</div>
                      </div>

                      <v-file-input
                        show-size
                        v-model="files"
                        multiple
                        counter
                        accept="image/*,application/pdf"
                        outlined
                        flat
                        prepend-icon=""
                        prepend-inner-icon="mdi-paperclip"
                        placeholder="Seleccionar archivos..."
                        class="rounded-xl elite-input"
                        hide-details
                      >
                        <template v-slot:selection="{ text, index }">
                          <v-chip
                            small
                            label
                            close
                            @click:close="remove(index)"
                            color="primary"
                            dark
                            class="font-weight-black rounded-lg mr-2"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                   </div>
                </v-col>
              </v-row>

              <div class="d-flex justify-end mt-4">
                 <v-btn
                  color="primary"
                  x-large
                  depressed
                  class="rounded-xl font-weight-black px-12 letter-spaced shadow-glow"
                  @click="addInforme()"
                >
                  ENVIAR INFORME
                </v-btn>
              </div>
            </v-card>

            <!-- Info Reminder -->
            <v-alert outlined color="primary" class="rounded-xl mt-8 glass-alert">
               <div class="d-flex align-center">
                  <v-icon color="primary" class="mr-4">mdi-information-outline</v-icon>
                  <div class="text-caption font-weight-medium primary--text">
                    Su informe será procesado por el departamento de Tesorería en un plazo de 24 a 48 hs hábiles. 
                    Podrá ver el estado en la sección de Consultas.
                  </div>
               </div>
            </v-alert>
          </v-col>
        </v-row>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "InformarPago",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title:"Informar pago",
    titulo: '',
    files:[],
  }),

  methods: {
    remove (index) {
      this.files.splice(index, 1)
    },

    async addInforme() {
      if(this.titulo.trim()  == "" ){
        alert('Porfavor, indique la cuota que paga')
        return;
      }
      
      if(this.files.length == 0){
        alert('Porfavor, agregue comprobante de pago')
        return;
      }

      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consulta-acreditacion/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.titulo = "";
          this.files = [];
        });
    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 100% 100%, #0f172a 0%, #1a237e 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-heavy {
  background: white;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid rgba(26, 35, 126, 0.05) !important;
}

/* Elite Form Inputs */
.elite-input ::v-deep fieldset {
  border-color: rgba(0,0,0,0.08) !important;
  transition: border-color 0.3s;
}
.elite-input:hover ::v-deep fieldset {
  border-color: rgba(0,0,0,0.15) !important;
}
.elite-input.v-input--is-focused ::v-deep fieldset {
  border-color: #1a237e !important;
  border-width: 2px;
}

.elite-input ::v-deep .v-input__slot {
  background: #f8fafc !important;
}

/* Upload Zone */
.elite-upload-zone {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1 !important;
}
.elite-upload-zone:hover {
  border-color: #1a237e !important;
  background: #eff6ff;
}

/* Icon Box */
.elite-icon-box {
  width: 54px;
  height: 54px;
  background: #eff6ff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shadow-premium {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.08) !important;
}

.shadow-glow {
  box-shadow: 0 10px 20px -5px rgba(26, 35, 126, 0.3) !important;
}

.glass-alert {
  background: rgba(239, 246, 255, 0.5) !important;
  border: 1px solid #dbeafe !important;
}

.letter-spaced {
  letter-spacing: 1px !important;
}

.uppercase { text-transform: uppercase; }
.text-tiny { font-size: 0.75rem !important; }

.transition-all {
  transition: all 0.3s ease;
}
</style>


